import { reduce, set, pickBy, map, chain, get, isUndefined, isEmpty } from "lodash"

export const STATUSES = {
  RESTRICTED: "restricted",
  DISABLED: "disabled",
  RELEASED: "released",
}

export function applyPermissions(features, value) {
  return reduce(features, (acc, feature) => feature && set(acc, feature.id, value), {})
}

export function computePermissions(features, entityFeatures) {
  const currentPermissions = {
    ...applyPermissions(features, false),
    // Only features that are in both lists can have permissions
    ...chain(features)
      .intersectionBy(entityFeatures, ({ id }) => id)
      .thru((features) => applyPermissions(features, true))
      .value(),
  }
  return currentPermissions
}

export function computeNewPermissions(features, entityFeatures, newEntityFeaturesPermissions) {
  const currentPermissions = computePermissions(features, entityFeatures)
  if (isEmpty(newEntityFeaturesPermissions)) { return {} }

  const newPermissions = {
    ...currentPermissions,
    ...newEntityFeaturesPermissions,
  }

  const featureExists = (featureId) => !isUndefined(get(currentPermissions, featureId))
  const hasPermissionChanged = (checked, featureId) => checked !== currentPermissions[featureId]
  return pickBy(newPermissions, (checked, featureId) => featureExists(featureId) && hasPermissionChanged(checked, featureId))
}

export async function updatePermissions(newEntityFeaturePermissions, features, entityFeatures, account, entity, entityType, update, onError, onSuccess) {
  const featuresToUpdate = computeNewPermissions(features, entityFeatures, newEntityFeaturePermissions)
  const promiseResolver = (resolve, reject) => (errorMessage) => {
    if (!errorMessage) {
      resolve("ok")
    } else {
      reject(errorMessage)
    }
  }
  try {
    const values = await Promise.all(map(featuresToUpdate, (checked, featureId) => {
      return new Promise((resolve, reject) => {
        const verb = checked ? "POST" : "DELETE"
        update(`/api/admin/${entityType}/${entity.id}/features/${featureId}`, {}, account, { verb }, promiseResolver(resolve, reject))
      })
    }))
    onSuccess(values)
  } catch (error) {
    onError(error)
  }
}
